import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import _get from "lodash/get";
import _omit from "lodash/omit";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import NwApiSDK from '@nerdwallet/nw-api-sdk';
import { createAsyncAction, createOptimisticAction } from "./utils";
export var updateProfile = createAsyncAction('updateProfile', function (_ref) {
  var data = _ref.data,
      profileType = _ref.profileType,
      _ref$showMessages = _ref.showMessages,
      showMessages = _ref$showMessages === void 0 ? false : _ref$showMessages,
      meta = _ref.meta;
  return {
    makeRequest: function makeRequest(_ref2, opts) {
      var identity = _ref2.identity;
      // shimUDP is used to toggle between legacy and current IdentitySDK profile methods
      var updateMethod = opts.shimUDP ? 'updateMyProfile' : 'updateProfile';
      var createMethod = opts.shimUDP ? 'createMyProfile' : 'createProfile';
      var method = identity.profiles[profileType] ? updateMethod : createMethod;
      return opts.IdentitySDK[method]({
        id: identity.current.id
      }, profileType, data);
    },
    parseSuccess: function parseSuccess(resp) {
      return {
        profileType: profileType,
        data: resp
      };
    },
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      showMessages: showMessages,
      profileType: profileType
    })
  };
});
export var updateProfileOptimistic = createOptimisticAction('updateProfile', function (data, oldData, identityCurrentId, profileExists, profileType) {
  return {
    effect: {
      profileExists: profileExists,
      profileType: profileType,
      data: data,
      identityCurrentId: identityCurrentId
    },
    payload: {
      profileType: profileType,
      data: data
    },
    rollback: {
      profileType: profileType,
      oldData: oldData
    },
    commit: {
      profileType: profileType
    }
  };
}, function (_ref3, opts) {
  var profileExists = _ref3.profileExists,
      profileType = _ref3.profileType,
      data = _ref3.data,
      identityCurrentId = _ref3.identityCurrentId;
  // shimUDP is used to toggle between legacy and current IdentitySDK profile methods
  var updateMethod = opts.shimUDP ? 'updateMyProfile' : 'updateProfile';
  var createMethod = opts.shimUDP ? 'createMyProfile' : 'createProfile';
  var method = profileExists ? updateMethod : createMethod;
  return opts.IdentitySDK[method]({
    id: identityCurrentId
  }, profileType, data);
});
export var readProfile = createAsyncAction('readProfile', function (_ref4) {
  var profileType = _ref4.profileType,
      meta = _ref4.meta,
      serverRequest = _ref4.serverRequest;
  return {
    makeRequest: function makeRequest(_ref5, opts) {
      var identity = _ref5.identity;
      // shimUDP is used to toggle between legacy and current IdentitySDK profile methods
      var readMethod = opts.shimUDP ? 'readMyProfile' : 'readProfile';
      return opts.IdentitySDK[readMethod]({
        id: identity.current.id
      }, profileType, serverRequest);
    },
    parseSuccess: function parseSuccess(resp) {
      return {
        /*
         * Native seems to have an option enable to parse request data to include
         * meta and headers information into the response object.
         * https://github.com/NerdWallet/js-nw-api-sdk/blob/6d960488a11002da606884319cc56a9abefb8be5/src/identity-sdk.js#L273-L277
         * For security reasons ignoring these fields for this api call, to avoid storing them in the state.
         */
        data: _omit(resp, ['__meta', '__headers']),
        profileType: profileType
      };
    },
    meta: _objectSpread(_objectSpread({}, meta), {}, {
      profileType: profileType
    })
  };
}); // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var readYodleeProfile = function readYodleeProfile(serverRequest) {
  return readProfile({
    actionName: 'readYodleeProfile',
    profileType: NwApiSDK.IDENTITY_PROFILES.YODLEE_PROFILE,
    serverRequest: serverRequest
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var readCreditBuilderProfile = function readCreditBuilderProfile(serverRequest) {
  return readProfile({
    actionName: 'readCreditBuilderProfile',
    profileType: NwApiSDK.IDENTITY_PROFILES.CREDIT_BUILDER_PROFILE,
    serverRequest: serverRequest
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateName = function updateName(data) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateName',
    profileType: NwApiSDK.IDENTITY_PROFILES.GLOBAL_PROFILE,
    data: data,
    showMessages: showMessages,
    meta: {
      updating: 'name'
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateSubscriptions = function updateSubscriptions(data) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateSubscriptions',
    profileType: NwApiSDK.IDENTITY_PROFILES.SUBSCRIPTION_PROFILE,
    data: data,
    showMessages: showMessages,
    meta: {
      updating: 'subscriptions'
    }
  });
};
export var updateSubscriptionsOptimistic = createOptimisticAction('updateSubscriptions', function (subscriptions, subscriptionChanges, identityCurrentId, subscriptionProfile) {
  return {
    effect: {
      subscriptionProfile: subscriptionProfile,
      identityCurrentId: identityCurrentId,
      subscriptions: subscriptions
    },
    payload: subscriptions,
    rollback: subscriptionChanges
  };
}, function (_ref6, opts) {
  var subscriptionProfile = _ref6.subscriptionProfile,
      identityCurrentId = _ref6.identityCurrentId,
      subscriptions = _ref6.subscriptions;
  var updateMethod = opts.shimUDP ? 'updateMyProfile' : 'updateProfile';
  var createMethod = opts.shimUDP ? 'createMyProfile' : 'createProfile';
  var method = subscriptionProfile ? updateMethod : createMethod;
  return opts.IdentitySDK[method]({
    id: identityCurrentId
  }, NwApiSDK.IDENTITY_PROFILES.SUBSCRIPTION_PROFILE_V2, subscriptions);
}); // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateCreditScorePurpose = function updateCreditScorePurpose(data) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateCreditScorePurpose',
    profileType: NwApiSDK.IDENTITY_PROFILES.MY_NERDWALLET_PROFILE,
    data: data,
    showMessages: showMessages,
    meta: {
      updating: 'creditPurpose',
      purpose: _get(data, 'purpose_for_credit_score[0]')
    }
  });
}; // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export var updateCreditScoreGoal = function updateCreditScoreGoal(data) {
  var showMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return updateProfile({
    actionName: 'updateCreditScoreGoal',
    profileType: NwApiSDK.IDENTITY_PROFILES.MY_NERDWALLET_PROFILE,
    data: data,
    showMessages: showMessages,
    meta: {
      updating: 'creditScoreGoal'
    }
  });
};
/** @deprecated Credit Builder v2 is a deprecated feature. */

export var fetchCreditBuilderRecommendationsV2 = createAsyncAction('fetchCreditBuilderRecommendationsV2', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.CreditServiceSDK.CreditBuilder.getRecommendationsV2();
    }
  };
});
/** @deprecated Credit Builder v2 is a deprecated feature. */

export var markRepeatCreditBuilderUser = createAsyncAction('markRepeatCreditBuilderUser', function () {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.CreditServiceSDK.CreditBuilder.markRepeatUser();
    }
  };
});
/**
 * This action first checks if investing profile has a location, doing
 * nothing if so, and if not, uses GeoservicesSDK to look up lat/lon
 * based on IP and then update investing profile. It takes in
 * dispatch as an argument to be able to do a second profile update if
 * necessary, as there is no clean way of accessing GeoservicesSDK
 * outside of the async actions framework inside js-auth-tools.
 */

export var ensureInvestingLatLon = createAsyncAction('ensureInvestingLatLon', function (dispatch) {
  return {
    makeRequest: function makeRequest(_ref7, opts) {
      var identity = _ref7.identity;

      var currentLoc = _get(identity, 'profiles.investing_profile.current_location.latitude');

      if (currentLoc) {
        return Promise.resolve();
      }

      return opts.GeoservicesSDK.ipInfo().then(function (data) {
        var latitude = data.latitude,
            longitude = data.longitude;

        if (!latitude || !longitude) {
          return Promise.reject();
        }

        return dispatch(updateProfile({
          actionName: 'updateInvestingLatLon',
          profileType: NwApiSDK.IDENTITY_PROFILES.INVESTING_PROFILE,
          data: {
            current_location: {
              latitude: latitude,
              longitude: longitude
            }
          },
          showMessages: false,
          meta: {
            updating: 'investingLatLon'
          }
        }));
      });
    }
  };
});
export var readProfileSuccess = readProfile.success;
export var updateProfileStart = updateProfile.start;
export var updateProfileSuccess = updateProfile.success;
export var updateProfileFail = updateProfile.fail;
export var unsubscribe = createAsyncAction('unsubscribe', function (token, type, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.unsubscribe(token, type, serverRequest);
    }
  };
});
export var unsubscribeV2 = createAsyncAction('unsubscribe_v2', function (token, type, serverRequest) {
  return {
    makeRequest: function makeRequest(state, opts) {
      return opts.IdentitySDK.unsubscribeV2(token, type, serverRequest);
    }
  };
});